import { render, staticRenderFns } from "./RecentDocuments.vue?vue&type=template&id=2bbca674"
import script from "./RecentDocuments.vue?vue&type=script&lang=ts"
export * from "./RecentDocuments.vue?vue&type=script&lang=ts"
import style0 from "./RecentDocuments.vue?vue&type=style&index=0&id=2bbca674&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports